/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

const ACTION_BLUE = "#2b4fb9";

export const exportDialogTitleStyles = {
  fontSize: "18px",
  fontWeight: 700,
  color: "#111827",
};

export const exportDialogDescriptionStyles = {
  fontSize: "14px",
  color: "#52525b",
  marginBottom: "8px",
};

export const exportRadioStyles = {
  color: ACTION_BLUE,
  "&.Mui-checked": { color: ACTION_BLUE },
};

export const exportDialogActionsStyles = {
  padding: "16px 24px",
  borderTop: "1px solid #e5e7eb",
  justifyContent: "flex-end",
  gap: "12px",
};
